import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { TranslateService } from '@ngx-translate/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { NotificationService } from '@services/notification/notification.service';

@Injectable()
export class ErrorHandlerInterceptorInterceptor implements HttpInterceptor {
    constructor(
        private notificationService: NotificationService,
        private translations: TranslateService,
    ) {}

    intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        return next.handle(request).pipe(
            catchError((err: HttpErrorResponse) => {
                console.error({
                    url: request?.urlWithParams || null,
                    method: request?.method || 'unknown',
                    body: request?.body || {},
                    headers: this.getHeaders(request),
                    params: this.getParams(request),
                    responseType: request?.responseType || 500,
                    message: err?.error?.message || err?.message || 'Unknown error',
                });

                const errorMessage = err?.error?.message;
                if (errorMessage) {
                    if (typeof errorMessage === 'string') {
                        this.notificationService.error(this.translations.instant(errorMessage || 'Unknown error'));
                    }
                    if (errorMessage?.args && Object.keys(errorMessage?.args).length > 0) {
                        this.notificationService.error(
                            this.translations.instant(errorMessage.code, { ...errorMessage.args }) || 'Unknown error',
                        );
                    } else if (errorMessage?.code) {
                        this.notificationService.error(
                            this.translations.instant(errorMessage.args.code) || 'Unknown error',
                        );
                    }
                }
                return throwError(err);
            }),
        );
    }

    private getHeaders(request: HttpRequest<unknown>): object {
        try {
            const headers = {};
            for (const [key, value] of request?.headers['headers']?.entries() ?? []) {
                headers[key] = value;
            }
            return headers;
        } catch {
            return {};
        }
    }

    private getParams(request: HttpRequest<unknown>): object {
        try {
            if (request?.params['map']?.size > 0) {
                const headers = {};
                for (const [key, value] of request?.params['map']?.entries() ?? []) {
                    headers[key] = value;
                }
                return headers;
            }
            return {};
        } catch {
            return {};
        }
    }
}
